(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menu-1"]) return;
  try {
      
document.addEventListener(
  'mouseover',
  function (event) {
    const tab = event.target.closest('[data-megamenu-tab]');
    if (!tab) return;

    if (event.relatedTarget && tab.contains(event.relatedTarget)) {
      return;
    }

    const megaMenu = tab.closest('.mega-menu-1');
    if (!megaMenu) return;

    const selectedValue = tab.getAttribute('data-megamenu-tab');

    megaMenu.querySelectorAll('[data-megamenu-tab]').forEach(function (currentTab) {
      const isActive =
        currentTab.getAttribute('data-megamenu-tab') === selectedValue;

      currentTab.classList.toggle('is-active', isActive);
      currentTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      currentTab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    megaMenu.querySelectorAll('[data-megamenu-panel]').forEach(function (panel) {
      const isActive =
        panel.getAttribute('data-megamenu-panel') === selectedValue;

      panel.classList.toggle('is-active', isActive);

      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  },
  true
);

  } catch(e) { console.error(e); }
})();
})();
